/**
 * Custom JS by RoarTheme Agent
 * https://haloroar.ticksy.com
 */
document.addEventListener('DOMContentLoaded', () => {
    const miniCart = document.querySelector('.mini-cart');
    if (!miniCart) return; 

    const isCartPage = window.location.pathname === '/cart';
    if (isCartPage) {
        miniCart.style.pointerEvents = 'none';
        return;
    }

    const raleContainer = document.querySelector('.rale-container');
    if (raleContainer) {
        raleContainer.style.padding = '0 8px';
    }
});
